import React from 'react';
import classNames from 'classnames';
import styles from './UnsupportedTemplateBubble.scss';
import { withTranslation } from 'react-i18next';
var UnsupportedTemplateBubble = function (_a) {
    var message = _a.message, eventHooks = _a.eventHooks;
    var _b = (message === null || message === void 0 ? void 0 : message.templateData) || {}, text = _b.text, buttons = _b.buttons, title = _b.title;
    var button = buttons === null || buttons === void 0 ? void 0 : buttons[0];
    return (React.createElement("div", { "data-hook": "unsupported-template-wrapper", className: classNames(styles.wrapper) },
        React.createElement("div", { className: classNames(styles.title), "data-hook": "unsupported-template-title" }, title),
        React.createElement("span", { "data-hook": "unsupported-template-text" }, text),
        ' ',
        React.createElement("a", { "data-hook": "unsupported-template-button", onClick: function () {
                var _a;
                (_a = eventHooks === null || eventHooks === void 0 ? void 0 : eventHooks.onCallToActionClick) === null || _a === void 0 ? void 0 : _a.call(eventHooks, button === null || button === void 0 ? void 0 : button.cta);
            } }, button === null || button === void 0 ? void 0 : button.text)));
};
export default withTranslation()(UnsupportedTemplateBubble);
//# sourceMappingURL=UnsupportedTemplateBubble.js.map